module.exports = __webpack_public_path__ + "media/img/home/img_thumb-3-9a873d3589b9b125deb2020663d31042.png";